import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { getViewAndUpdatePaymentMethodsCTA } from "./shared";

export const ViewOrUpdatePaymentMethodsIA: InstantAnswerBuilderFn = (
  strictLocalize
) => {
  return {
    titleBuilder: (_context) => {
      return VIEW_OR_UPDATE_PAYMENT_METHODS(strictLocalize);
    },

    descriptionBuilder: (_context) => {
      return [VIEW_OR_UPDATE_PAYMENT_METHODS_EXPLANATION(strictLocalize)];
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getViewAndUpdatePaymentMethodsCTA(context, strictLocalize)
          ?.label;
      },
      linkBuilder: (context) => {
        return getViewAndUpdatePaymentMethodsCTA(
          context,
          strictLocalize
        )?.getLink?.();
      },
    },
  };
};

const VIEW_OR_UPDATE_PAYMENT_METHODS = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "View or update payment methods",
    description: {
      text: "Title for the answer about how to view or update payment methods",
    },
  });

const VIEW_OR_UPDATE_PAYMENT_METHODS_EXPLANATION = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "You can view or update your payment methods by clicking the button below. For future reference, this option is located in your Settings tab in the Account dropdown menu.",
    description: {
      text: "Description for the answer about how to view or update payment methods",
    },
  });
